
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("azYNm", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsLoader", () => $4048f2d5e9ff9162$export$74cf87e24679ef23);
$parcel$export(module.exports, "Breadcrumbs", () => $4048f2d5e9ff9162$export$2dc68d50d56fbbd);
$parcel$export(module.exports, "BreadcrumbsNonLoadable", () => $4048f2d5e9ff9162$export$8bb26699ba16d6a3);
$parcel$export(module.exports, "FixedBreadcrumbsNavForPageLayoutLoader", () => $4048f2d5e9ff9162$export$f979c33d59431f8e);
$parcel$export(module.exports, "FixedSpaceHeaderContainer", () => (parcelRequire("8MMdp")).FixedSpaceHeaderContainer);
$parcel$export(module.exports, "FixedSpaceHeaderWithBannerContainer", () => (parcelRequire("8MMdp")).FixedSpaceHeaderWithBannerContainer);
$parcel$export(module.exports, "BREADCRUMB_HEADER_HEIGHT", () => (parcelRequire("8MMdp")).BREADCRUMB_HEADER_HEIGHT);
$parcel$export(module.exports, "BREADCRUMBS_MODES", () => (parcelRequire("5Vf1r")).BREADCRUMBS_MODES);
$parcel$export(module.exports, "buildContentPath", () => (parcelRequire("hzkzq")).buildContentPath);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $eCJDV = parcelRequire("eCJDV");

var $8MMdp = parcelRequire("8MMdp");

var $5Vf1r = parcelRequire("5Vf1r");

var $hzkzq = parcelRequire("hzkzq");

const $4048f2d5e9ff9162$export$74cf87e24679ef23 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "b4n75",
    name: "BreadcrumbsLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("8MMdp")))).Breadcrumbs,
    loading: (0, $eCJDV.BreadcrumbsPlaceholder)
});
const $4048f2d5e9ff9162$export$2dc68d50d56fbbd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4048f2d5e9ff9162$export$74cf87e24679ef23, props);
const $4048f2d5e9ff9162$export$8bb26699ba16d6a3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8MMdp.Breadcrumbs), props);

const $4048f2d5e9ff9162$export$f979c33d59431f8e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "r9MLy",
    name: "FixedBreadcrumbsNavForPageLayoutLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("8MMdp")))).FixedBreadcrumbsNavForPageLayout
});

});
parcelRegister("eCJDV", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsPlaceholder", () => $0c4308f795e44815$export$98d1f051069dd73b);

var $gwFzn = parcelRequire("gwFzn");

var $fwDOR = parcelRequire("fwDOR");
function $0c4308f795e44815$export$98d1f051069dd73b() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fwDOR.default), {
        name: "BreadcrumbsPlaceholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "breadcrumbs-placeholder",
        "data-vc": "breadcrumbs-placeholder"
    }));
}

});

parcelRegister("8MMdp", function(module, exports) {

$parcel$export(module.exports, "BREADCRUMB_HEADER_HEIGHT", () => $6d14bad88596319b$export$947cbc4fd63441e3);
$parcel$export(module.exports, "FixedSpaceHeaderContainer", () => $6d14bad88596319b$export$ba9528a5a0141231);
$parcel$export(module.exports, "Breadcrumbs", () => $6d14bad88596319b$export$2dc68d50d56fbbd);
$parcel$export(module.exports, "FixedBreadcrumbsNavForPageLayout", () => $6d14bad88596319b$export$7d2750c639212b06);
$parcel$export(module.exports, "FixedSpaceHeaderWithBannerContainer", () => $6d14bad88596319b$export$5adc3a1912461c1e);
/* Breadcrumbs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $fppBw = parcelRequire("fppBw");

var $j1Ss3 = parcelRequire("j1Ss3");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $dIouf = parcelRequire("dIouf");

var $1NBp8 = parcelRequire("1NBp8");

var $cb6fO = parcelRequire("cb6fO");
var $7zgzO = parcelRequire("7zgzO");

var $kDja4 = parcelRequire("kDja4");

var $ep3mz = parcelRequire("ep3mz");

var $cEgMD = parcelRequire("cEgMD");

var $3joiD = parcelRequire("3joiD");

var $jmjWc = parcelRequire("jmjWc");
var $luv00 = parcelRequire("luv00");

var $9wGTI = parcelRequire("9wGTI");

var $irVI7 = parcelRequire("irVI7");
var $ln0hx = parcelRequire("ln0hx");

var $gCX2C = parcelRequire("gCX2C");

var $bpoON = parcelRequire("bpoON");

var $gz8ZY = parcelRequire("gz8ZY");

var $eCJDV = parcelRequire("eCJDV");

var $hzkzq = parcelRequire("hzkzq");

var $i23fb = parcelRequire("i23fb");

var $5Vf1r = parcelRequire("5Vf1r");

const $6d14bad88596319b$var$CompanyHubBreadcrumbs = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rj-y7",
    name: "CompanyHubBreadcrumbs",
    loader: async ()=>(await (parcelRequire("5QiLw"))).CompanyHubBreadcrumbs
});
const $6d14bad88596319b$export$947cbc4fd63441e3 = 56;
const $6d14bad88596319b$var$i18n = (0, $2nPZH.defineMessages)({
    archivedPagesBreadcrumbsTitle: {
        id: "breadcrumbs.archived-pages-list-link",
        defaultMessage: "Archived content"
    },
    archivedContentBreadcrumbsTitle: {
        id: "breadcrumbs.archived-content-list-link",
        defaultMessage: "Archived"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $6d14bad88596319b$export$ba9528a5a0141231 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNav4Enabled: isNav4Enabled, isFullWidth: isFullWidth, isThemed: isThemed, isObjectHeaderEnabled: isObjectHeaderEnabled, shouldHavePadding: shouldHavePadding, isModernizedBreadcrumbsEnabled: isModernizedBreadcrumbsEnabled, isTransparent: isTransparent, justifyContent: justifyContent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ji2brd": (0, $iAWao.default)(__cmplp.justifyContent || 'space-between')
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_n7zlglyw _4t3i8vuz _1pby1ial _1bsb1osq _1e0c1txw _4cvr1h6o _vchhusvi _1bah1vxp",
            !__cmplp.isNav4Enabled && __cmplp.isFullWidth ? "_p12fglyw" : "_p12f18ua",
            __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
            __cmplp.isThemed || __cmplp.isObjectHeaderEnabled && !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : __cmplp.isModernizedBreadcrumbsEnabled ? "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf" : "_ca0qidpf _u5f31f4h _n3tdidpf _19bv1f4h",
            __cmplp.isTransparent ? "_bfhk18uv" : "_bfhkvuon",
            __cmplp.isNav4Enabled ? "_1ltv1d4h" : "_1ltv1wug",
            __cmplp.className
        ])
    });
});
const $6d14bad88596319b$var$SpaceHeaderWithBannerWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFullWidth: isFullWidth, isThemed: isThemed, isTransparent: isTransparent, isNav4Enabled: isNav4Enabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_n7zlglyw _1pby1ial _1bsb1osq _1e0c1txw _2lx21bp4 _vchhusvi",
            __cmplp.isFullWidth ? "_p12fglyw" : "_p12f18ua",
            __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
            __cmplp.isTransparent ? "_bfhk18uv" : "_bfhkvuon",
            __cmplp.isFullWidth ? "_1ltvidpf" : "_1ltv1d4h",
            __cmplp.isNav4Enabled ? "_18u0idpf" : "_18u0yh40",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $6d14bad88596319b$var$SpaceHeaderWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isThemed: isThemed, isObjectHeaderEnabled: isObjectHeaderEnabled, shouldHavePadding: shouldHavePadding, isModernizedBreadcrumbsEnabled: isModernizedBreadcrumbsEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4t3i8vuz _1e0c1txw _4cvr1h6o",
            __cmplp.isThemed || __cmplp.isObjectHeaderEnabled && !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : __cmplp.isModernizedBreadcrumbsEnabled ? "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf" : "_ca0qidpf _u5f31f4h _n3tdidpf _19bv1f4h",
            __cmplp.isModernizedBreadcrumbsEnabled ? "_zulpyh40" : "_zulpidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6d14bad88596319b$var$BreadcrumbWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "nav", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { compact: compact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2hwxpxbi _1e0c1txw _4cvr1h6o _16jlidpf _1ul9idpf",
            __cmplp.compact ? "_1wyb1crf" : "_1wybdlk8",
            __cmplp.className
        ])
    });
});
$6d14bad88596319b$export$2dc68d50d56fbbd.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    /**
   * Show an extra breadcrumb item when it is provided.
   * This is used in sticky content header where we want to display the title of the current page.
   */ contentTitle: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    /**
   * Include the current content when true
   */ includeSelf: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    /**
   * For modernised breadcrumbs, if a content link value is provided, allow the content title portion to link to that
   * (used for views like page analytics and version history)
   */ contentLink: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string
};
function $6d14bad88596319b$export$2dc68d50d56fbbd({ compact: compact, contentId: contentId, contentTitle: contentTitle, spaceKey: spaceKey, includeSelf: includeSelf, testId: testId, showInlineRename: showInlineRename, shouldDisableMoveButton: shouldDisableMoveButton, displayMode: displayMode = (0, $5Vf1r.BREADCRUMBS_MODES).FULL, contentLink: contentLink, contentType: contentType, subType: subType }) {
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { match: match } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const intl = (0, $dBxQj.default)();
    if (!spaceKey) return null;
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6d14bad88596319b$var$CompanyHubBreadcrumbs, null);
    const fireBreadcrumbError = (error)=>{
        let err;
        let nativeError;
        try {
            err = JSON.stringify(error, Object.getOwnPropertyNames(error)); // https://stackoverflow.com/a/26199752
            nativeError = JSON.stringify(error['nativeError']);
        } catch  {
            // if no error, means it failed to stringify so just set as empty string
            if (!err) err = '';
            if (!nativeError) nativeError = '';
        } finally{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'breadcrumbs',
                    action: 'errored',
                    actionSubject: 'viewPageBreadcrumbs',
                    attributes: {
                        message: error.message,
                        error: err,
                        nativeError: nativeError
                    }
                }
            }).fire();
        }
    };
    if ((0, $9wGTI.fg)('confluence_modernized_breadcrumbs')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.GenericErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO,
        onError: fireBreadcrumbError,
        renderOnError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5Vf1r.BreadcrumbsWithSpaceNameDropdown), {
        contentTitle: contentTitle,
        spaceKey: spaceKey || '',
        contentId: contentId,
        testId: testId,
        showInlineRename: showInlineRename,
        shouldDisableMoveButton: shouldDisableMoveButton,
        displayMode: displayMode,
        contentLink: contentLink,
        contentType: contentType,
        subType: subType
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.GenericErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO,
        onError: fireBreadcrumbError,
        renderOnError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.Query), (0, $3joiD.getQueryPropsAndSetFetchPolicyForNetworkOnlyQuery)({
        query: (0, $bpoON.BreadcrumbsQuery),
        context: {
            single: true
        },
        variables: {
            spaceKey: spaceKey,
            contentId: contentId,
            skipContent: !contentId
        } // No fetch policy here because we are relying on network-only preloader to get the latest data
    }), ({ data: data, error: error })=>{
        // Note don't check for loading as when refreshing data we will get data={...} and loading=true
        // In this case if we display the placeholder it will flash before the data is displayed
        // We should continue render with existing data and then update when the new data is available
        if (!data || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eCJDV.BreadcrumbsPlaceholder), null);
        const space = data?.spaces?.nodes?.[0];
        const content = data?.content?.nodes?.[0]; // we need both space data and content (if requested)
        if (!space) // @TODO fixme: should we really silently return null here?
        // If it's possible for us to get graphql data but not these
        // fields, something seems wrong
        return null;
        const spaceHomepageId = space?.homepage?.id;
        const spaceOverviewPath = (0, $hzkzq.buildContentPath)({
            contentType: 'page',
            isSpaceOverview: true,
            query: spaceHomepageId ? {
                [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: spaceHomepageId
            } : undefined,
            spaceAlias: space.alias,
            spaceKey: spaceKey
        });
        const ancestors = content ? (0, $hzkzq.filterAncestors)(content, spaceHomepageId).map(({ id: id, title: title, type: type })=>({
                href: (0, $hzkzq.buildContentPath)({
                    contentId: id,
                    contentSlug: (0, $cb6fO.generateSlug)(title || undefined),
                    contentType: type,
                    isSpaceOverview: false,
                    spaceAlias: space.alias,
                    spaceKey: spaceKey
                }),
                id: id || '',
                title: title || '',
                contentType: type || undefined
            })) : [];
        if (content?.status === (0, $hzkzq.CONTENT_STATUS_ARCHIVED) || (0, $gCX2C.getSkipContentAndTypes)(match?.name).isArchivedPagesList) {
            const archivePagesListLink = {
                href: (0, $1NBp8.SPACE_ARCHIVED_PAGES).toUrl({
                    spaceKey: space.alias || spaceKey
                }),
                title: intl.formatMessage(isWhiteboardFeatureEnabled('whiteboardsEnabled') ? $6d14bad88596319b$var$i18n.archivedContentBreadcrumbsTitle : $6d14bad88596319b$var$i18n.archivedPagesBreadcrumbsTitle),
                id: 'archived_pages_list'
            };
            ancestors.unshift(archivePagesListLink);
        }
        if (includeSelf && content) {
            const { title: title, id: id, type: type } = content;
            if (title && id && type) {
                const self = {
                    href: (0, $hzkzq.buildContentPath)({
                        contentId: id,
                        contentSlug: (0, $cb6fO.generateSlug)(title),
                        contentType: type,
                        isSpaceOverview: false,
                        spaceAlias: space.alias,
                        spaceKey: spaceKey
                    }),
                    id: id,
                    title: title
                }; // add yourself as an ancestor in breadcrumbs
                ancestors.push(self);
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6d14bad88596319b$var$BreadcrumbWrapper, {
            compact: compact,
            "aria-label": "Breadcrumbs",
            "data-vc": "breadcrumbs-loader",
            ...ssrPlaceholderIdProp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i23fb.BreadcrumbsPicker), {
            ancestors: ancestors,
            contentTitle: contentTitle || '',
            spaceName: space.name || space.alias || spaceKey,
            spaceOverviewPath: spaceOverviewPath,
            compact: compact
        }));
    })));
}
const $6d14bad88596319b$export$7d2750c639212b06 = ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6d14bad88596319b$export$ba9528a5a0141231, {
        isModernizedBreadcrumbsEnabled: (0, $9wGTI.fg)('confluence_modernized_breadcrumbs')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6d14bad88596319b$export$2dc68d50d56fbbd, {
        spaceKey: spaceKey
    }));
};
const $6d14bad88596319b$export$5adc3a1912461c1e = ({ children: children, banner: banner, isThemed: isThemed, shouldHavePadding: shouldHavePadding, isFullWidth: isFullWidth, isTransparent: isTransparent, testId: testId })=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6d14bad88596319b$var$SpaceHeaderWithBannerWrapper, {
        isThemed: isThemed,
        isFullWidth: isFullWidth,
        isTransparent: isTransparent,
        isNav4Enabled: isNav4Enabled
    }, banner, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6d14bad88596319b$var$SpaceHeaderWrapper, {
        isThemed: isThemed,
        "data-testid": testId,
        isModernizedBreadcrumbsEnabled: (0, $9wGTI.fg)('confluence_modernized_breadcrumbs'),
        isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_object_header'),
        shouldHavePadding: shouldHavePadding
    }, children));
};

});
parcelRegister("hzkzq", function(module, exports) {

$parcel$export(module.exports, "CONTENT_STATUS_ARCHIVED", () => $b055c0b5c16164d3$export$41b2e06f27dfe96e);
$parcel$export(module.exports, "buildContentPath", () => $b055c0b5c16164d3$export$6b45500787cf696);
$parcel$export(module.exports, "filterAncestors", () => $b055c0b5c16164d3$export$d3865786a3f7be67);
$parcel$export(module.exports, "getEmojiFromPublishedPageProperties", () => $b055c0b5c16164d3$export$f6641c501f8a1aee);
$parcel$export(module.exports, "getEmojiFromDraftPageProperties", () => $b055c0b5c16164d3$export$e1cb12562674727b);
$parcel$export(module.exports, "getIsTextTruncated", () => $b055c0b5c16164d3$export$52c8bba571728790);

var $1NBp8 = parcelRequire("1NBp8");
const $b055c0b5c16164d3$export$41b2e06f27dfe96e = 'archived';
const $b055c0b5c16164d3$export$6b45500787cf696 = ({ contentId: contentId, contentSlug: contentSlug, contentType: contentType, isSpaceOverview: isSpaceOverview, query: query, spaceAlias: spaceAlias, spaceKey: spaceKey })=>{
    if (contentType === 'folder') return '#';
    let route;
    if (isSpaceOverview) route = (0, $1NBp8.SPACE_OVERVIEW);
    else switch(contentType){
        case 'blogpost':
            route = (0, $1NBp8.VIEW_BLOG);
            break;
        case 'page':
            route = (0, $1NBp8.VIEW_PAGE);
            break;
        case 'whiteboard':
            route = (0, $1NBp8.WHITEBOARD_BOARD);
            break;
        case 'database':
            route = (0, $1NBp8.DATABASE_VIEW);
            break;
        case 'embed':
            route = (0, $1NBp8.EMBED_VIEW);
            break;
        default:
            throw new Error(`Received an unexpected content type: '${contentType}'`);
    }
    return route.toUrl({
        contentId: contentId,
        contentSlug: contentSlug,
        spaceKey: spaceAlias || spaceKey
    }, {
        query: query
    });
};
const $b055c0b5c16164d3$export$d3865786a3f7be67 = ({ ancestors: ancestors, status: status }, spaceHomepageId)=>{
    if (!ancestors) return [];
    // If current page is archived, filter out non-archived ancestors
    if (status === $b055c0b5c16164d3$export$41b2e06f27dfe96e) ancestors = ancestors.filter((ancestor)=>ancestor && ancestor.status === $b055c0b5c16164d3$export$41b2e06f27dfe96e);
    else // technically array elements can be null
    ancestors = ancestors.filter((node)=>node);
    if (!ancestors.length) return ancestors;
    if (ancestors[0].id !== spaceHomepageId && ancestors[ancestors.length - 1].id === spaceHomepageId) return ancestors.reverse().slice(1);
    if (ancestors[0].id === spaceHomepageId) return ancestors.slice(1);
    return ancestors;
};
const $b055c0b5c16164d3$export$f6641c501f8a1aee = (properties)=>{
    if (!properties) return undefined;
    const values = properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $b055c0b5c16164d3$export$e1cb12562674727b = (properties)=>{
    if (!properties) return undefined;
    const values = properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $b055c0b5c16164d3$export$52c8bba571728790 = (textRef)=>{
    if (textRef.current) return textRef.current.scrollWidth > textRef.current.clientWidth;
    return false;
};

});

parcelRegister("i23fb", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsPicker", () => $bd2563cf85b1d596$export$8d34d157af825926);
/* BreadcrumbsPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $3gadb = parcelRequire("3gadb");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $jmjWc = parcelRequire("jmjWc");

var $4K4h4 = parcelRequire("4K4h4");

var $kjXns = parcelRequire("kjXns");

var $gF3hr = parcelRequire("gF3hr");

var $gUqw5 = parcelRequire("gUqw5");

const $bd2563cf85b1d596$export$20cf4420e6ad0d7b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "y57pO",
    name: "LazyBreadrumbsEllipsisPopup",
    loader: async ()=>(await Promise.resolve((parcelRequire("8livF")))).BreadcrumbsAncestorsDropdownButton,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gF3hr.BreadcrumbsAncestorsDropdownButtonPlaceholder), null)
});
const $bd2563cf85b1d596$var$separatorStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    pointerEvents: 'none'
});
const $bd2563cf85b1d596$var$Separator = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $bd2563cf85b1d596$var$separatorStyles,
        paddingInlineStart: "space.100",
        paddingInlineEnd: "space.100"
    }, "/");
const $bd2563cf85b1d596$var$MAX_WIDTH_BREADCRUMBS = '570px';
const $bd2563cf85b1d596$var$breadcrumbsStyles = (0, $ecnYn.xcss)({
    minWidth: '0px',
    // needed for responsive breadcrumbs
    maxWidth: $bd2563cf85b1d596$var$MAX_WIDTH_BREADCRUMBS
});
const $bd2563cf85b1d596$var$BREADCRUMBS_ITEM_MIN_WIDTH = '16px'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd2563cf85b1d596$var$BreadcrumbLinkWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1ul97vkz _tkqh1txw _bnh47vkz _3uv91osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-html-anchor -- To migrate as part of go/ui-styling-standard
const $bd2563cf85b1d596$var$BreadcrumbLink = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCurrentPage: isCurrentPage, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _1reo15vq _18m915vq _1e0c1ule _o5721q9c _1ul97vkz _1bto1l2s _y3gn1h6o _1w901gjq _1fh11gjq _1f1j1gjq _1l5a1gjq",
            __cmplp.isCurrentPage ? "_80om73ad _p12f1mjv _1toh18uv _ow0718uv _el8t18uv _5jyqglyw _17rjglyw _12piglyw _mrqmnqa1 _1iqunqa1 _1lwpnqa1" : "_80omtlke _p12f1w81",
            __cmplp.className
        ])
    });
});
const $bd2563cf85b1d596$var$folderItemStyles = (0, $ecnYn.xcss)({
    flexShrink: 1,
    display: 'inline-block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd2563cf85b1d596$var$FolderItem = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { compact: compact, isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19itysnf _2rko1y44 _ca0q1y44 _u5f3ftgi _n3td1y44 _19bvftgi _18s8b0ox _syaz1gjq _k48pi7a9 _bfhk18uv _80omtlke _1ul97vkz _u1mb166n",
            __cmplp.compact ? "_1wyb1crf" : "_1wybdlk8",
            __cmplp.isSelected && "_syazaqb7 _bfhkfg4m _u1mbi1yw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd2563cf85b1d596$var$BreadrumbsEllipsisWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $bd2563cf85b1d596$var$BreadcrumbItem = ({ title: title, href: href, onClick: onClick, ancestors: ancestors, isCurrentPage: isCurrentPage = false, contentType: contentType, contentId: contentId, compact: compact })=>{
    const intl = (0, $dBxQj.default)();
    const isFolder = contentType === 'folder';
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClickFolderDropdownItem = (content, depth)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'breadcrumb',
                source: 'breadcrumbsFolderButton',
                attributes: {
                    breadcrumbsTotal: ancestors.length + 1,
                    origin: 'view-page',
                    nestedDepth: depth + 2,
                    destination: (0, $kjXns.GenericBreadcrumbItemTitles).Ancestor,
                    titleLength: content.title.length
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$BreadcrumbLinkWrapper, null, isFolder && contentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gUqw5.BreadcrumbsFolderPopup), {
        contentId: contentId,
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        placement: "bottom-start",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
                content: title,
                hideTooltipOnClick: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$FolderItem, {
                ...triggerProps,
                onClick: ()=>setIsOpen((v)=>!v),
                isSelected: isOpen,
                compact: compact
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4K4h4.ContentTreeIcon), {
                type: contentType,
                label: intl.formatMessage($bd2563cf85b1d596$var$i18n.folder),
                color: isOpen ? "var(--ds-text-selected, #0C66E4)" : undefined
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                as: "span",
                xcss: $bd2563cf85b1d596$var$folderItemStyles
            }, title)))),
        handleClickFolderDropdownItem: handleClickFolderDropdownItem
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: title,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$BreadcrumbLink, {
        href: href,
        onClick: onClick,
        isCurrentPage: isCurrentPage
    }, title)));
};
function $bd2563cf85b1d596$export$8d34d157af825926({ ancestors: ancestors, contentTitle: contentTitle, spaceName: spaceName, spaceOverviewPath: spaceOverviewPath, compact: compact }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onBreadcrumbClick = (attributes)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'breadcrumb',
                    source: 'containerNavigation',
                    attributes: {
                        breadcrumbsTotal: ancestors.length + 1,
                        origin: 'view-page',
                        ...attributes
                    }
                }
            }).fire();
        };
    const handleClickAncestorBreadcrumb = (title, depth)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'breadcrumb',
                source: 'breadcrumbsEllipsisButton',
                attributes: {
                    breadcrumbsTotal: ancestors.length + 1,
                    origin: 'view-page',
                    nestedDepth: depth + 2,
                    destination: (0, $kjXns.GenericBreadcrumbItemTitles).Ancestor,
                    titleLength: title.length
                }
            }
        }).fire();
    };
    const renderInnerBreadcrumbs = (ancestors)=>{
        const dropdownAncestors = ancestors.slice(0, ancestors.length - 1);
        const lastInnerAncestor = ancestors[ancestors.length - 1];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, dropdownAncestors.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$Separator, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$BreadrumbsEllipsisWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$export$20cf4420e6ad0d7b, {
            ancestors: dropdownAncestors,
            handleClickAncestorBreadcrumb: handleClickAncestorBreadcrumb
        }))), lastInnerAncestor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$Separator, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$BreadcrumbItem, {
            contentId: lastInnerAncestor.id,
            title: lastInnerAncestor.title,
            href: lastInnerAncestor.href,
            onClick: ()=>handleClickAncestorBreadcrumb(lastInnerAncestor.title, ancestors.length - 1),
            ancestors: ancestors,
            contentType: lastInnerAncestor.contentType,
            compact: compact
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $bd2563cf85b1d596$var$breadcrumbsStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$BreadcrumbItem, {
        title: spaceName,
        href: spaceOverviewPath,
        onClick: onBreadcrumbClick({
            nestedDepth: 1,
            destination: (0, $kjXns.GenericBreadcrumbItemTitles).Space,
            titleLength: spaceName.length
        }),
        ancestors: ancestors,
        compact: compact
    }), renderInnerBreadcrumbs(ancestors), contentTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$Separator, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$BreadcrumbItem, {
        title: contentTitle,
        href: "#",
        onClick: onBreadcrumbClick({
            nestedDepth: ancestors.length + 2,
            destination: (0, $kjXns.GenericBreadcrumbItemTitles).ContentTitle,
            titleLength: contentTitle.length
        }),
        ancestors: ancestors,
        isCurrentPage: true,
        compact: compact
    })));
}
const $bd2563cf85b1d596$var$i18n = (0, $2nPZH.defineMessages)({
    folder: {
        id: "breadcrumbs.picker.folder",
        defaultMessage: "Folder"
    }
});

});
parcelRegister("gF3hr", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsAncestorsDropdownButtonPlaceholder", () => $e575f928bde0dbd7$export$d84187c34d9b4ae6);

var $gwFzn = parcelRequire("gwFzn");

var $9VJDA = parcelRequire("9VJDA");

var $8livF = parcelRequire("8livF");
const $e575f928bde0dbd7$export$d84187c34d9b4ae6 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8livF.BreadcrumbsEllipsisButton), {
        isSelected: false,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
            label: "More",
            color: "var(--ds-icon, #44546F)"
        }),
        "data-vc": "breadcrumbs-ellipsis-button-placeholder"
    });
};

});

parcelRegister("gUqw5", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsFolderPopup", () => $5af50a45bc36e00c$export$7d591fd4f4b1c7b1);
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $diswb = parcelRequire("diswb");

var $lGgRw = parcelRequire("lGgRw");

var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $9hlns = parcelRequire("9hlns");

var $dIouf = parcelRequire("dIouf");

var $jlIaF = parcelRequire("jlIaF");

var $6B8C0 = parcelRequire("6B8C0");
const $5af50a45bc36e00c$var$BreadcrumbsFolderPopupBreadcrumbsFolderChildrenQuery = (0, $d2LG0.default)`query BreadcrumbsFolderPopupBreadcrumbsFolderChildrenQuery($contentId:ID!){ptpage(id:$contentId status:[CURRENT]){id children(first:5){nodes{id title type links{webui}emojiTitlePublished:properties(key:"emoji-title-published"){nodes{id key value version{number}}}}pageInfo{hasNextPage endCursor}}}}`;
const $5af50a45bc36e00c$export$7d591fd4f4b1c7b1 = ({ contentId: contentId, isOpen: isOpen, onClose: onClose, trigger: trigger, placement: placement, handleClickFolderDropdownItem: handleClickFolderDropdownItem })=>{
    return(// TODO: Add `shouldRenderToParent` to component to improve accessibility. See
    // https://a11y.atlassian.net/browse/JCATS-788
    // https://hello.atlassian.net/wiki/spaces/DST/pages/5402216605/shouldRenderToParent+prop+usages+in+cc-disco+packages
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        trigger: trigger,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5af50a45bc36e00c$var$BreadcrumbsFolderContent, {
                contentId: contentId,
                handleClickFolderDropdownItem: handleClickFolderDropdownItem
            }),
        isOpen: isOpen,
        onClose: onClose,
        placement: placement
    }));
};
const $5af50a45bc36e00c$var$BreadcrumbsFolderContent = ({ contentId: contentId, handleClickFolderDropdownItem: handleClickFolderDropdownItem })=>{
    const { loading: loading, data: data, error: error } = (0, $diswb.useQuery)($5af50a45bc36e00c$var$BreadcrumbsFolderPopupBreadcrumbsFolderChildrenQuery, {
        variables: {
            contentId: contentId
        }
    });
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $5af50a45bc36e00c$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
        size: "large"
    }));
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $5af50a45bc36e00c$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $5af50a45bc36e00c$var$i18n.error)));
    const contents = data?.ptpage?.children?.nodes?.filter($5af50a45bc36e00c$var$isTruthy).map((c)=>({
            id: c.id,
            type: c.type || '',
            title: c.title || '',
            href: `${0, $jlIaF.CONTEXT_PATH}${c.links?.webui}`
        })) || [];
    const hasMore = data?.ptpage?.children?.pageInfo?.hasNextPage;
    if (!contents.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $5af50a45bc36e00c$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $5af50a45bc36e00c$var$i18n.empty));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6B8C0.BreadcrumbsContentMenu), {
        contents: contents,
        showIndentIcon: false,
        hasMore: hasMore,
        onLinkItemClick: handleClickFolderDropdownItem
    });
};
const $5af50a45bc36e00c$var$containerStyles = (0, $ecnYn.xcss)({
    width: '280px',
    paddingInline: 'space.150',
    paddingBlock: 'space.500',
    color: 'color.text.subtlest'
});
function $5af50a45bc36e00c$var$isTruthy(value) {
    return value !== null && value !== undefined;
}
const $5af50a45bc36e00c$var$i18n = (0, $2nPZH.defineMessages)({
    error: {
        id: "breadcrumbs.folder.error",
        defaultMessage: "Error loading folder contents"
    },
    empty: {
        id: "breadcrumbs.folder.empty",
        defaultMessage: "There\u2019s nothing in this folder yet."
    }
});

});


parcelRegister("5Vf1r", function(module, exports) {

$parcel$export(module.exports, "BREADCRUMBS_MODES", () => $7c978e5ad74fbe60$export$14e8342ddf0a4616);
$parcel$export(module.exports, "BreadcrumbsWithSpaceNameDropdown", () => $7c978e5ad74fbe60$export$c71a066c29807b48);
/* BreadcrumbsWithSpaceNameDropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $ghftu = parcelRequire("ghftu");

var $5izcQ = parcelRequire("5izcQ");

var $inPa6 = parcelRequire("inPa6");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $lGgRw = parcelRequire("lGgRw");

var $3gadb = parcelRequire("3gadb");

var $9wGTI = parcelRequire("9wGTI");

var $ilxH8 = parcelRequire("ilxH8");

var $jmjWc = parcelRequire("jmjWc");
var $luv00 = parcelRequire("luv00");

var $kqIWy = parcelRequire("kqIWy");
var $bMPhU = parcelRequire("bMPhU");

var $irVI7 = parcelRequire("irVI7");
var $gfIPU = parcelRequire("gfIPU");
var $1eaCJ = parcelRequire("1eaCJ");
var $1kHsc = parcelRequire("1kHsc");

var $dIouf = parcelRequire("dIouf");

var $1NBp8 = parcelRequire("1NBp8");

var $dPJCf = parcelRequire("dPJCf");

var $bCECL = parcelRequire("bCECL");

var $hbrew = parcelRequire("hbrew");

var $6mKj3 = parcelRequire("6mKj3");

var $ePiuX = parcelRequire("ePiuX");

var $hzkzq = parcelRequire("hzkzq");

const $7c978e5ad74fbe60$var$BreadcrumbsDropdownContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "d_JWZ",
    name: "BreadcrumbsDropdownContent",
    loader: async ()=>(await (parcelRequire("h3Yp7"))).BreadcrumbsDropdownContent
});

const $7c978e5ad74fbe60$var$BreadcrumbsPlaceholder = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "YZZqh",
    name: "BreadcrumbsPlaceholder",
    loader: async ()=>(await Promise.resolve((parcelRequire("eCJDV")))).BreadcrumbsPlaceholder
});
const $7c978e5ad74fbe60$var$separatorStyles = null;
const $7c978e5ad74fbe60$var$hiddenStyles = null;
const $7c978e5ad74fbe60$var$hiddenContentTitleStyles = null;
const $7c978e5ad74fbe60$var$hideSeparatorStyles = null;
const $7c978e5ad74fbe60$var$breadcrumbsStyles = (0, $ecnYn.xcss)({
    minWidth: '32px',
    // needed for responsive breadcrumbs, 32px is the width of the chevron button
    alignItems: 'center',
    flex: '0 1 auto',
    gap: 'space.100'
});
const $7c978e5ad74fbe60$var$fadedSpaceNameTextStyles = null;
const $7c978e5ad74fbe60$var$spaceNameTextStyles = null;
const $7c978e5ad74fbe60$var$noEllipsisStyles = null;
const $7c978e5ad74fbe60$var$breadcrumbDropdownTriggerStyles = null;
const $7c978e5ad74fbe60$var$maxWidthBreadcrumbsDropdownTriggerStyles = null;
const $7c978e5ad74fbe60$var$maxWidthOnlyContentTitleTriggerStyles = null;
const $7c978e5ad74fbe60$var$currentPageBreadcrumbStyles = null;
const $7c978e5ad74fbe60$var$currentPageLinkBreadcrumbStyles = null;
const $7c978e5ad74fbe60$var$contentTitleStyles = null;
const $7c978e5ad74fbe60$var$chevronBaseStyles = (0, $ecnYn.xcss)({
    width: '32px',
    minWidth: '32px',
    height: '32px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'color.background.neutral.subtle'
});
const $7c978e5ad74fbe60$var$chevronHoverStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
var $7c978e5ad74fbe60$export$14e8342ddf0a4616 = /*#__PURE__*/ function(BREADCRUMBS_MODES) {
    BREADCRUMBS_MODES["ONLY_CONTENT_TITLE"] = "ONLY_CONTENT_TITLE";
    BREADCRUMBS_MODES["ONLY_SPACE_NAME"] = "ONLY_SPACE_NAME";
    BREADCRUMBS_MODES["FULL"] = "FULL";
    BREADCRUMBS_MODES["HIDDEN"] = "HIDDEN";
    return BREADCRUMBS_MODES;
}({});
const $7c978e5ad74fbe60$export$c71a066c29807b48 = ({ contentTitle: contentTitle, spaceKey: spaceKey, contentId: contentId, testId: testId = 'breadcrumbs-with-space-name-dropdown', showInlineRename: showInlineRename = false, shouldDisableMoveButton: shouldDisableMoveButton = false, displayMode: displayMode, contentLink: contentLink, contentType: contentType, subType: subType })=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isBreadcrumbsPopupOpen, setIsBreadcrumbsPopupOpen] = (0, $gwFzn.useState)(false);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { data: spaceData, error: error } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const spaceHomepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { isNetworkDisabled: isNetworkDisabled } = (0, $hbrew.useEditorNetworkStatus)();
    const isBreadcrumbsDisabled = isNetworkDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false); // Note don't check for loading as when refreshing data we will get data={...} and loading=true
    // In this case if we display the placeholder it will flash before the data is displayed
    // We should continue render with existing data and then update when the new data is available
    if (error || !spaceData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE),
        error: error
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7c978e5ad74fbe60$var$BreadcrumbsPlaceholder, null));
    const spaceName = spaceData.name || spaceData.alias || spaceKey;
    const isSpaceNameLongerThan6Letters = spaceName?.length > 6;
    const contentTitleToRender = contentTitle === '' ? intl.formatMessage($7c978e5ad74fbe60$var$i18n.untitledPage) : contentTitle;
    const shouldOpenDropdown = contentTitleToRender || showInlineRename;
    const shouldShowCurrentContentTitle = contentTitleToRender && !showInlineRename;
    const spaceOverviewPath = (0, $hzkzq.buildContentPath)({
        contentType: 'page',
        isSpaceOverview: true,
        query: spaceHomepageId ? {
            [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: spaceHomepageId
        } : undefined,
        spaceAlias: spaceData.alias,
        spaceKey: spaceKey
    });
    const handleBreadcrumbDropdownTriggerClick = ()=>{
        if (shouldOpenDropdown) {
            if (!isBreadcrumbsPopupOpen) {
                experienceTracker.start({
                    name: (0, $irVI7.BREADCRUMBS_DROPDOWN_EXPERIENCE)
                });
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'opened',
                        actionSubject: 'breadcrumbsDropdown',
                        source: 'breadcrumbs',
                        attributes: {
                            isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_object_header')
                        }
                    }
                }).fire();
            }
            setIsBreadcrumbsPopupOpen(!isBreadcrumbsPopupOpen);
        } else push(spaceOverviewPath);
    };
    const popupContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7c978e5ad74fbe60$var$BreadcrumbsDropdownContent, {
            spaceKey: spaceKey,
            contentId: contentId,
            closeDropdownOnClickOfBreadcrumbItem: closeDropdownOnClickOfBreadcrumbItem,
            spaceOverviewPath: spaceOverviewPath,
            shouldDisableMoveButton: shouldDisableMoveButton,
            contentTitle: contentTitleToRender
        });
    };
    const closeDropdownOnClickOfBreadcrumbItem = ()=>{
        setIsBreadcrumbsPopupOpen(false);
    };
    const preloadBreadcrumbsDropdownOnSpaceNameHover = ()=>{
        (0, $ePiuX.preloadBreadcrumbsDropdown)({
            spaceKey: spaceKey,
            contentId: contentId
        });
    };
    const renderContentTitle = ()=>{
        const titleElement = contentLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
            href: contentLink,
            className: (0, $35pXk.default)([
                "_1reo15vq _18m915vq _11c8140y _o5721q9c _1bto1l2s _1ul91tcg _syaz1fxt _10531fxt _1vhv1fxt _1m0aglyw"
            ])
        }, contentTitleToRender) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            className: (0, $35pXk.default)([
                "_1reo15vq _18m915vq _11c8140y _o5721q9c _1bto1l2s _1ul91tcg _syaz1fxt _1m0aglyw"
            ])
        }, contentTitleToRender);
        const wrappedTitleElement = (0, $9wGTI.fg)('confluence_frontend_object_header') ? titleElement : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
            name: (0, $ilxH8.LIVE_DOC_MODES_TOGGLE_TARGET)
        }, titleElement);
        if ((0, $9wGTI.fg)('confluence_frontend_breadcrumbs_dom_manipulation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            id: "breadcrumbs-content-title",
            className: (0, $35pXk.default)([
                "_zulpu2gc _1reo15vq _18m915vq _v564glyw _1e0c1txw _4cvr1h6o _tzy4kb7n _p12f1c3h",
                (displayMode === "HIDDEN" || displayMode === "ONLY_SPACE_NAME") && "_tzy4idpf _p12fidpf"
            ])
        }, (contentType === 'page' || contentType === 'blogpost') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bCECL.ContentIcon), {
            type: contentType,
            subType: subType,
            color: "var(--ds-text, #172B4D)"
        }), wrappedTitleElement);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, (contentType === 'page' || contentType === 'blogpost') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bCECL.ContentIcon), {
            type: contentType,
            subType: subType,
            color: "var(--ds-text, #172B4D)"
        }), wrappedTitleElement);
    };
    const renderSpaceName = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            id: "breadcrumbs-space-name",
            className: (0, $35pXk.default)([
                "_1reo15vq _18m915vq _11c82smr _1bto1l2s _1bsb1osq _o5721q9c _p12f1osq",
                shouldOpenDropdown && "_1bton7od",
                shouldOpenDropdown && isSpaceNameLongerThan6Letters && "_1nwp1wyi _1w801wyi",
                (displayMode === "HIDDEN" || displayMode === "ONLY_CONTENT_TITLE") && (0, $9wGTI.fg)('confluence_frontend_breadcrumbs_dom_manipulation') && "_1e0cglyw"
            ])
        }, spaceName);
    };
    const renderSeparator = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            id: "breadcrumbs-separator",
            className: (0, $35pXk.default)([
                "_syaz1gjq _lcxvglyw _1o9zidpf _2hwx1b66 _18u01b66",
                !showInlineRename && "_1m0aglyw",
                displayMode != "FULL" && (0, $9wGTI.fg)('confluence_frontend_breadcrumbs_dom_manipulation') && "_1e0cglyw"
            ])
        }, "/");
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $7c978e5ad74fbe60$var$breadcrumbsStyles,
        testId: testId,
        "data-vc": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        isOpen: isBreadcrumbsPopupOpen,
        onClose: ()=>setIsBreadcrumbsPopupOpen(false),
        placement: "bottom-start",
        content: popupContent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("button", {
                id: "breadcrumbs-dropdown-chevron-button",
                "data-testId": "breadcrumbs-dropdown-chevron-button",
                disabled: isBreadcrumbsDisabled,
                onClick: handleBreadcrumbDropdownTriggerClick,
                onMouseEnter: preloadBreadcrumbsDropdownOnSpaceNameHover,
                "aria-label": "Breadcrumbs",
                ...triggerProps,
                ...ssrPlaceholderIdProp,
                className: (0, $35pXk.default)([
                    "_2rko1y44 _19it3acm _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1rjcidpf _18zridpf _1e0c1o8l _80omtlke _1o9zidpf _1bsb1osq _bfhk1w7a _syaz131l _1vnv18uv _1b5cglyw _1avfnqa1 _10fu131l _j5dh73ad _f8pj1gjq _mizu1p6i _1ah3v77o _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _9h8h1fxt",
                    shouldOpenDropdown && "_p12fp3fh _1bsbn7od _8fz6ucft",
                    displayMode === "ONLY_CONTENT_TITLE" && "_p12f1osq _1bto1l2s _8fz61osq",
                    displayMode === "HIDDEN" && (0, $9wGTI.fg)('confluence_frontend_breadcrumbs_dom_manipulation') && "_1e0cglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
                alignItems: "center",
                gap: "space.100"
            }, shouldOpenDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
                content: !isBreadcrumbsDisabled && intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonTooltip),
                hideTooltipOnClick: true
            }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                    xcss: [
                        $7c978e5ad74fbe60$var$chevronBaseStyles,
                        !isBreadcrumbsDisabled && $7c978e5ad74fbe60$var$chevronHoverStyles
                    ],
                    ...tooltipProps
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "",
                    color: "var(--ds-icon-subtle, #626F86)",
                    size: "small"
                }))), displayMode !== "ONLY_CONTENT_TITLE" || (0, $9wGTI.fg)('confluence_frontend_breadcrumbs_dom_manipulation') ? renderSpaceName() : showInlineRename ? null : renderContentTitle()))
    }), (displayMode === "FULL" || (0, $9wGTI.fg)('confluence_frontend_breadcrumbs_dom_manipulation')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, shouldOpenDropdown && renderSeparator(), shouldShowCurrentContentTitle && renderContentTitle()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
    }));
};
const $7c978e5ad74fbe60$var$i18n = (0, $2nPZH.defineMessages)({
    untitledPage: {
        id: "breadcrumbs.dropdown.untitled-page.default-title",
        defaultMessage: "Untitled"
    },
    breadcrumbsChevronButtonTooltip: {
        id: "breadcrumbs.dropdown.button.chevron.tooltip",
        defaultMessage: "Show navigation path"
    }
});

});
parcelRegister("ePiuX", function(module, exports) {

$parcel$export(module.exports, "preloadBreadcrumbsDropdown", () => $e956eba1dd4bb7db$export$e5d3f19aa88b9c61);

var $dYU3e = parcelRequire("dYU3e");

var $iibKQ = parcelRequire("iibKQ");
function $e956eba1dd4bb7db$export$e5d3f19aa88b9c61({ spaceKey: spaceKey, contentId: contentId }) {
    return (0, $dYU3e.query)({
        query: (0, $iibKQ.ModernizedBreadcrumbsQuery),
        variables: {
            spaceKey: spaceKey,
            contentId: contentId,
            skipContent: !contentId
        }
    });
}

});
parcelRegister("iibKQ", function(module, exports) {

$parcel$export(module.exports, "ModernizedBreadcrumbsQuery", () => $fe32fc813e468bd2$export$9c8d605c16743dd0);

var $d2LG0 = parcelRequire("d2LG0");
const $fe32fc813e468bd2$export$9c8d605c16743dd0 = (0, $d2LG0.default)`query ModernizedBreadcrumbsQuery($spaceKey:String!$contentId:ID$skipContent:Boolean!){space(key:$spaceKey){alias id name icon{path}homepage{id}}content(id:$contentId status:["current" "draft" "archived"])@skip(if:$skipContent){nodes{id type subType status properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}ancestors{id type subType title status properties(keys:["emoji-title-published"]){nodes{id key value}}}}}}`;

});


parcelRegister("h3Yp7", function(module, exports) {

let $c6c19281903fa5f0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c6c19281903fa5f0$var$load("6vzdH"),
    $c6c19281903fa5f0$var$load("aIO5d"),
    $c6c19281903fa5f0$var$load("ffEVr"),
    $c6c19281903fa5f0$var$load("joJy8"),
    $c6c19281903fa5f0$var$load("aHE9G"),
    $c6c19281903fa5f0$var$load("1GyAj")
]).then(()=>parcelRequire('auDgK'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("5QiLw", function(module, exports) {

let $44105d7faad8f027$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $44105d7faad8f027$var$load("1vHyq"),
    $44105d7faad8f027$var$load("ffEVr"),
    $44105d7faad8f027$var$load("joJy8"),
    $44105d7faad8f027$var$load("aHE9G"),
    $44105d7faad8f027$var$load("b6JBs")
]).then(()=>parcelRequire('g3Wvh'));

});




//# sourceMappingURL=FullPageEditorComponent.951c09a4.js.map
